export const API_ENDPOINTS = {
  ACCOMMODATIONS: {
    GET_ACCOMMODATIONS:
      "/omaliittyma-api/accommodations/getomaliittymaallaccommodations",
    GET_AVAILABLE_ACCOMMODATIONS:
      "/omaliittyma-api/accommodations/getomaliittymaavailableaccommodations",
    GET_BOOKING_CHANGE_POSSIBLE:
      "/omaliittyma-api/accommodations/isaccommodationavailableignoregivenbooking",
    GET_ACCOMMODATION_DETAILS_BASIC:
      "/omaliittyma-api/accommodations/getOmaLiittymaAccommodationDetailsBasic",
    GET_ACCOMMODATION_IMAGES:
      "/omaliittyma-api/accommodations/getOmaLiittymaAccommodationImages",
    GET_ACCOMMODATION_ATTRIBUTES:
      "/omaliittyma-api/accommodations/GetOmaliittymaAccommodationAttributes",
    GET_ALL_ACCOMMODATION_ATTRIBUTES:
      "/omaliittyma-api/accommodations/GetOmaliittymaAllAccommodationAttributes",
    GET_ACCOMMODATION_ADDONS:
      "/omaliittyma-api/accommodations/GetOmaliittymaAccommodationAddOns",
    SET_ACCOMMODATION_KEYBOX:
      "/omaliittyma-api/accommodations/UpdateOmaLiittymaAccommodationKeybox",
    SET_ACCOMMODATION_GEOCODE:
      "/omaliittyma-api/accommodations/UpdateOmaLiittymaAccommodationGeoCode",
    SEND_ACCOMMODATION_CHANGE_REQUEST:
      "/omaliittyma-api/accommodations/SendOmaLiittymaAccommodationChangeRequest",
  },
  BOOKING: {
    GET_BOOKINGS: "/omaliittyma-api/bookings/getBookings",
    GET_BOOKINGS_FOR_CALENDAR:
      "/omaliittyma-api/bookings/GetBookingsForCalendar",
    GET_BOOKINGS_FOR_CALENDAR_BATCH:
      "/omaliittyma-api/bookings/GetBookingsForCalendarBatch",
    GET_BOOKINGS_BY_IDS: "/omaliittyma-api/bookings/GetBookingsByIds",
    GET_BOOKING: "/omaliittyma-api/bookings/getBookingDetails",
    CANCEL_BOOKING: "/omaliittyma-api/bookings/cancelBooking",
    SAVE_BOOKING_OWNERNOTE: "/omaliittyma-api/bookings/addBookingOwnerNote",
    SAVE_OWNER_OWN_BOOKING: "/omaliittyma-api/bookings/makeOwnerOwnBooking",
    UPDATE_OWNER_OWN_BOOKING: "/omaliittyma-api/bookings/updateOwnerOwnBooking",
    GET_ARRIVALS_AND_DEPARTURES:
      "/omaliittyma-api/bookings/GetDailyArrivalsAndDepartures",
    GET_BOOKINGS_STARTING_IN_SEVEN_DAYS:
      "/omaliittyma-api/bookings/GetBookingsStartingInSevenDays",
    GET_BOOKINGS_CREATED_IN_SEVEN_DAYS:
      "/omaliittyma-api/bookings/GetBookingsCreatedInSevenDays",
  },
  BLOCKEDPERIOD: {
    SAVE_BLOCKEDPERIOD_BOOKING_DETAILS:
      "/omaliittyma-api/blockedperiods/saveBlockedPeriodBookingDetails",
  },
  IDENTITY: {
    GET_ACCOMMODATION_ADDRESS:
      "/omaliittyma-api/identity/GetOmaLiittymaAccommodationAddressByAddressId",
    GET_IDENTITY: "/bff/user",
    GET_AUTHORIZATION_CLAIMS: "/identity/identity/GetAuthorizationClaims",
    GET_ACCOUNT_DETAILS: "/omaliittyma-api/ownerinfo/getaccountdetailsfromdb",
    SET_ACCOUNT_DETAILS: "/omaliittyma-api/ownerinfo/updateowner",
    // New endpoints to support selecting login account when multiple accounts share the same email
    GET_USER_ACCOUNTS: "/identity/identity/GetAccountsForCurrentUser",
    SELECT_LOGIN_ACCOUNT: "/identity/identity/SelectLoginAccount",
    // Strong authentication endpoints
    GET_PERSON_IDENTITY_DATA: "/identity/identity/getPersonalIdentityData",
  },
  COUNTRIES: {
    GET_COUNTRIES: "/omaliittyma-api/ownerinfo/getCountries",
  },
  FEEDBACKS: {
    GET_FEEDBACKS: "/omaliittyma-api/customerfeedbacks/getcustomerfeedbacks",
    GET_FEEDBACK: "/omaliittyma-api/customerfeedbacks/getcustomerfeedback",
    SET_FEEDBACK_OWNER_COMMENT:
      "/omaliittyma-api/customerfeedbacks/updatecustomerfeedbackownercomment",
  },
  RATES: {
    GET_ACCOMMODATION_RATES:
      "/omaliittyma-api/rates/GetSeasonRatesByAccommodationId",
    SET_ACCOMMODATION_RATE: "/omaliittyma-api/rates/updateSeasonRate",
    SAVE_ACCOMMODATION_RATE: "/omaliittyma-api/rates/addSeasonRate",
    DELETE_ACCOMMODATION_RATE: "/omaliittyma-api/rates/DeleteSeasonRate",
  },
  REPORTS: {
    GET_SETTLEMENT_REPORT: "/omaliittyma-api/report/GetSettlementReport",
  },
  ICAL: {
    GET_DISTRIBUTION_CHANNELS: "/omaliittyma-api/ical/getDistributionChannels",
    GET_IMPORTS: "/omaliittyma-api/ical/getImports",
    GET_EXPORTS: "/omaliittyma-api/ical/getExports",
    SAVE_IMPORT: "/omaliittyma-api/ical/saveImport",
    SAVE_EXPORT: "/omaliittyma-api/ical/saveExport",
    DELETE_IMPORT: "/omaliittyma-api/ical/deleteImport",
    DELETE_EXPORT: "/omaliittyma-api/ical/deleteExport",
    IMPORT_ICAL: "/omaliittyma-api/ical/importIcal",
  },
};
